import { Session } from "@paywithglide/glide-js";

// TODO: drop once @paywithglide/glide-js ships these fields on Session.
type SessionWithRefundChain = Session & {
  refundChainName?: string;
  refundChainLogoUrl?: string;
  refundCurrencySymbol?: string;
};

// Where a refund is paid out. Falls back to the actual payment chain so the
// widget keeps working against a backend that predates the refund fields.
export const refundChainOf = (session: SessionWithRefundChain) => {
  const name = session.refundChainName ?? session.actualPaymentChainName;
  return {
    name,
    logoUrl: session.refundChainLogoUrl ?? session.actualPaymentChainLogoUrl,
    currencySymbol:
      session.refundCurrencySymbol ?? session.actualPaymentCurrencySymbol,
    isConverted:
      !!session.refundChainName &&
      session.refundChainName !== session.actualPaymentChainName,
    placeholder:
      name === "Bitcoin"
        ? "bc1..."
        : name === "Solana"
          ? "11111..."
          : name === "Tron"
            ? "TR7N..."
            : "0x000...000",
  };
};
